import { merge, uniq, mergeWith, isObject } from "lodash";
import { getOrgChartPropertiesFromLocalStorage } from "../utils/storeInLocalStorage";
import { PANEL_ID } from "../components/OrgChartPanel/const";
import { ACTION_TYPES } from "./actionTypes";

export const initialOrgChartState = {
  loadedTeams: {},
  loadedMembers: {},
  data: null,
  team: null,
  viewOptions: {
    groupMembersBySupplyOrDemand: false,
    showPeople: true,
  },
  properties: {
    peopleData: [],
    teamsData: [],
  },
  expandedNodes: [],
  expandedPanel: {
    panelId: PANEL_ID.viewOptions,
    data: null,
  },
};

export const getInitialOrgChartState = ({ tagConfig }) => {
  const storedOrgChartProperties = getOrgChartPropertiesFromLocalStorage({
    tagConfig,
  });
  return merge(initialOrgChartState, storedOrgChartProperties);
};

export const orgChartReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_VIEW_OPTIONS: {
      return {
        ...state,
        viewOptions: {
          ...state.viewOptions,
          ...action.payload,
        },
      };
    }

    case ACTION_TYPES.UPDATE_PROPERTIES: {
      return {
        ...state,
        properties: {
          ...state.properties,
          ...action.payload,
        },
      };
    }
    case ACTION_TYPES.UPDATE_LOADED_DATA: {
      return {
        ...state,
        currentViewTeam: action.payload.currentViewTeam
          ? action.payload.currentViewTeam
          : state.currentViewTeam,
        loadedTeams: {
          ...state.loadedTeams,
          ...action.payload.loadedTeams,
        },
        loadedMembers: {
          ...state.loadedMembers,
          ...action.payload.loadedMembers,
        },
        expandedNodes: action.payload.expandedNodes
          ? uniq(action.payload.expandedNodes)
          : state.expandedNodes,
      };
    }

    case ACTION_TYPES.UPDATE_EXPANDED_TEAMS: {
      return {
        ...state,
        expandedNodes: uniq(action.payload.expandedNodes),
      };
    }
    case ACTION_TYPES.UPDATE_LOADED_TEAMS: {
      return {
        ...state,
        loadedTeams: { ...state.loadedTeams, ...action.payload },
      };
    }

    case ACTION_TYPES.UPDATE_PERSON_PARTIAL: {
      const { aggregateId } = action.payload;

      return {
        ...state,
        loadedMembers: {
          ...state.loadedMembers,
          [aggregateId]: {
            ...state.loadedMembers[aggregateId],
            ...action.payload,
          },
        },
      };
    }

    case ACTION_TYPES.MERGE_PARTIAL_DATA: {
      const mergeHandler = (obj, source) => {
        if (isObject(obj) || isObject(source)) {
          return { ...obj, ...source };
        }

        return source || obj;
      };

      return {
        ...state,
        loadedTeams: mergeWith(
          state.loadedTeams,
          action.payload.loadedTeams,
          mergeHandler
        ),
        loadedMembers: mergeWith(
          state.loadedMembers,
          action.payload.loadedMembers,
          mergeHandler
        ),
      };
    }

    case ACTION_TYPES.UPDATE_EXPANDED_PANEL: {
      return {
        ...state,
        expandedPanel: {
          ...state.expandedPanel,
          ...(action.payload.panelId !== undefined && {
            panelId: action.payload.panelId,
          }),
          ...(action.payload.data !== undefined && {
            data: {
              ...state.expandedPanel.data,
              ...action.payload.data,
            },
          }),
        },
      };
    }

    default:
      return state;
  }
};
